var exports = {
  "kL": "x4ddf2309--9c7f6e--container",
  "Qs": "x4ddf2309--9c7f6e--content",
  "x6": "x4ddf2309--9c7f6e--button",
};

module.exports = exports;
